export default "__VITE_ASSET__e8xLHJLH0Wlaqe4ABb0SXg__"